// CHECKER LIST
export const FETCH_CHECKER_LIST_REQUEST = 'FETCH_CHECKER_LIST_REQUEST';
export const FETCH_CHECKER_LIST_SUCCESS = 'FETCH_CHECKER_LIST_SUCCESS';
export const FETCH_CHECKER_LIST_ERROR = 'FETCH_CHECKER_LIST_ERROR';
export const SHOW_CHECKER_LOADER = 'SHOW_CHECKER_LOADER';
export const HIDE_CHECKER_LOADER = 'HIDE_CHECKER_LOADER';
